import React, { useEffect, useReducer, useRef } from 'react';
import { useMap } from '@vis.gl/react-google-maps';

import reducer, { useDrawingManagerEvents, useOverlaySnapshots } from './undo-redo';
import { DrawingActionKind } from './types';
import { DrawingController } from './use-drawing-manager';

interface Props {
  drawingController: DrawingController | null;
  locationUpdated: (polygon: string) => void;
  savedCoordinates: string | null;
}

export const UndoRedoControl = ({ drawingController, savedCoordinates, locationUpdated }: Props) => {
  const map = useMap();

  const [state, dispatch] = useReducer(reducer, {});

  useEffect(() => {
    const coordinates = state.now?.snapshot?.path?.map(latLng => ({
      lat: latLng.lat(),
      lng: latLng.lng(),
    }));

    if (coordinates) {
      locationUpdated(JSON.stringify(coordinates));
    }
  }, [state]);

  const overlaysShouldUpdateRef = useRef<boolean>(false);

  useDrawingManagerEvents(drawingController, overlaysShouldUpdateRef, dispatch, savedCoordinates);
  useOverlaySnapshots(map, state, overlaysShouldUpdateRef);

  const buttonStyle: React.CSSProperties = {
    marginTop: '10px',
    padding: '8px 16px',
    backgroundColor: drawingController?.isDrawing ? '#d93025' : '#1a73e8',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 500,
    boxShadow: '0 1px 4px rgba(0,0,0,0.3)',
  };

  return (
    <div>
      <button
        style={buttonStyle}
        onClick={() => {
          if (drawingController?.isDrawing) {
            drawingController.stopDrawing();
          } else {
            dispatch({ type: DrawingActionKind.CLEAR_OVERLAY });
            drawingController?.startDrawing();
          }
        }}
      >
        {drawingController?.isDrawing ? '✕ Cancel Drawing' : '+ Draw Zone'}
      </button>
    </div>
  );
};
